import { Stack } from '@mui/material'
import { stepGroups } from '@/features/chat/phase1/stepGroups'
import Pressable from '@/theme/Pressable'
import PublicTimelinePhase from './PublicTimelinePhase'
import StepGroupRow from './StepGroupRow'
import ThoughtStep from './thoughtchain/ThoughtStep'

export default function PublicTimelineContent({
  view,
  streaming,
  hasMore,
  loadMore,
  citations = [],
}) {
  const { phases, orphans } = view
  return (
    <Stack sx={{ gap: 0, mt: 0.75 }}>
      {phases.map((phase) => (
        <PublicTimelinePhase
          key={phase.id}
          phase={phase}
          streaming={streaming}
          citations={citations}
        />
      ))}
      {orphans.length ? (
        <ThoughtStep category="tasks" title="Other observed steps" streaming={streaming}>
          {stepGroups(orphans).map((group) => (
            <StepGroupRow key={group.id} group={group} streaming={streaming} />
          ))}
        </ThoughtStep>
      ) : null}
      {hasMore ? (
        <Pressable onClick={loadMore} sx={{ alignSelf: 'flex-start', fontSize: 'var(--app-thought-font-size)', textDecoration: 'underline' }}>
          Load more activity
        </Pressable>
      ) : null}
    </Stack>
  )
}
